/**
 * WheelIncomePage — full-page promotion of the Wheel Income Engine widget
 * (item 4 of the locked queue).
 *
 * Renders the same PIESection component that previously lived only inside
 * PortfolioPage. Users clicking a ticker in the Mode A / Mode B tables get
 * navigated to the ticker workbench (behaviour preserved from the widget).
 *
 * Mode A "Existing" already surfaces roll/close signals per user's iter125
 * ask — the `stage` chip (CC_WRITING / CSP_ACTIVE / IDLE) and `note`
 * column carry that logic. See PortfolioPage.js:495-521.
 */
import { TrendingUp } from "lucide-react";
import { PIESection } from "@/pages/PortfolioPage";

export default function WheelIncomePage() {
  return (
    <div className="p-4 space-y-4" data-testid="wheel-strategies-page">
      <div className="flex items-center gap-2">
        <TrendingUp className="w-4 h-4" style={{ color: "#10B981" }} />
        <div>
          <h1 className="text-lg font-bold" style={{ fontFamily: "Chivo, sans-serif" }}>
            Wheel &amp; Other Strategies
          </h1>
          <div className="text-[11px]" style={{ color: "var(--hoip-text-secondary)" }}>
            Options scenario modelling — new-entry candidates according to your settings. Screen basket against your
            NetLiq tier.
          </div>
        </div>
      </div>
      <PIESection />
      <p className="text-[10px] leading-relaxed" style={{ color: "var(--hoip-text-tertiary)" }}
        data-testid="wheel-methodology-disclosure">
        Model outputs depend on the assumptions and data inputs described above. Historical and simulated data may be
        incomplete or subject to error. Simulated results are not guarantees of future performance.
      </p>
    </div>
  );
}
